import { Component, OnInit } from "@angular/core";
import { Config } from "src/app/_config/config";
import { FormGroup, FormBuilder } from "@angular/forms";
import { DataService } from "../_service/data.service";
import { ExcelService } from "../_service/excel.service";
import __ from "underscore";
import { IDropdownSettings } from "ng-multiselect-dropdown";
@Component({
  selector: "app-vn-report",
  templateUrl: "./vn-mapping.component.html",
  styleUrls: ["./vn-mapping.component.scss"],
})
export class VNMappingComponent implements OnInit {
  parentDropdownSettings: IDropdownSettings;
  zoneDropdownSettings: IDropdownSettings;
  regionDropdownSettings: IDropdownSettings;
  channelDropdownSettings: IDropdownSettings;
  outletTypeDropdownSettings: IDropdownSettings;

  public config: any = new Config();

  public zoneList: any = [];
  public regionList: any = [];
  public parentList: any = [];
  public columnList: any = [];
  public channelList: any = [];
  public outletTypeList: any = [];

  public filterForm: FormGroup;
  public searchText: string = "";

  loginData: any;
  loggedUser: any;
  virtualNumberData: any = [];
  firstTimeRun: Boolean = true;

  zoneStatus: Boolean = false;
  regionStatus: Boolean = false;
  parentStatus: Boolean = false;
  outletStatus: Boolean = false;
  channelStatus: Boolean = false;

  selectedZone = [];
  selectedRegion = [];
  selectedParent = [];
  selectedColumn = [];
  selectedChannel = [];
  selectedOutletType = [];

  zone = [];
  region = [];
  parent = [];
  channel = [];

  apiReq = {
    zone: "",
    region: "",
    parent: "",
    channel: "",
    outletType: "",
    agl_flag: "",
  };
  currentPage: number = 1;
  pageSize: number = 10;
  totalRecords: number = 0;
  totalPages: number = 0;
  isLastPage: boolean = false;
  channelName: any = "";
  outletTypeName: any = "";
  constructor(
    private fb: FormBuilder,
    private dataService: DataService,
    private ExcelService: ExcelService
  ) {
    this.filterForm = this.fb.group({
      zone: [""],
      region: [""],
      parent_group: [""],
      outlet: [""],
      userType: [""],
    });
  }

  ngOnInit() {
    this.loginData = this.dataService.getCookies("loginData")
      ? JSON.parse(this.dataService.getCookies("loginData")).acl
      : JSON.parse(localStorage.getItem("loginData")).acl;

    if (this.loginData.userType === 6) {
      // TSM/RO
      this.parentStatus = true;
      this.getAllParent("aa");
    } else if (this.loginData.userType === 8) {
      // Zonal
      this.regionStatus = true;
      this.parentStatus = true;
      this.getAllRegion("aa");
    } else if (this.loginData.userType === 1) {
      // Agency or HO
      this.regionStatus = true;
      this.parentStatus = true;
      this.zoneStatus = true;
      this.channelStatus = true;
      this.getAllZone();
    } else if (this.loginData.userType === 7) {
      // Agency or HO
      this.regionStatus = true;
      this.parentStatus = true;
      this.zoneStatus = true;
      this.channelStatus = true;
      this.getAllZone();
    } else if (this.loginData.userType === 9) {
      this.parentStatus = true;
      this.outletStatus = true;
      this.channelStatus = true;
      this.getAllChannel("''");
    } else if (this.loginData.userType === 10) {
      // Zonal manager
      this.regionStatus = true;
      this.parentStatus = true;
      this.channelStatus = true;
      this.getAllRegion("aa");
    } else {
      this.regionStatus = true;
      this.outletStatus = true;
      this.channelStatus = true;
      this.getAllRegion("''");
    }

    this.filterForm.patchValue({
      userType: this.loginData.userType,
    });

    this.zoneSetting();
    this.regionSetting();
    this.parentSetting();
    this.channelSetting();
    this.outletTypeSetting();
    this.advanceFilter();
  }

  get isFilterApplied(): boolean {

  return (
    this.selectedZone.length > 0 ||
    this.selectedRegion.length > 0 ||
    this.selectedParent.length > 0 ||
    this.selectedChannel.length > 0 ||
    this.selectedOutletType.length > 0 
  );
}

  zoneSetting() {
    this.zoneDropdownSettings = {
      singleSelection: false,
      idField: "zone",
      textField: "zone",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 1,
      allowSearchFilter: true,
    };
  }

  onZoneSelect(item: any) {
    this.selectedZone.push(item.zone);
    let data = "'" + this.selectedZone.join("','") + "'";
    this.region = [];
    this.parent = [];
    this.apiReq.zone = data;
    this.getAllRegion(data);
  }
  onZoneAll(items: any) {
    this.selectedZone = [];
    this.region = [];
    this.parent = [];
    for (let i = 0; i < items.length; i++) {
      this.selectedZone.push(items[i].zone);
    }
    let data = "'" + this.selectedZone.join("','") + "'";
    this.apiReq.zone = data;
    this.getAllRegion(data);
  }
  onZoneDeSelect(item: any) {
    this.selectedZone.splice(this.selectedZone.indexOf(item.zone), 1);
    let data = "'" + this.selectedZone.join("','") + "'";
    this.apiReq.zone = data;
    this.region = [];
    this.parent = [];
    this.getAllRegion(data);
  }

  onZoneDeAll() {
    this.region = [];
    this.parent = [];
    this.selectedZone = [];
    this.regionList = [];
    this.apiReq.zone = "";
    this.getAllRegion("''");
  }

  regionSetting() {
    this.regionDropdownSettings = {
      singleSelection: false,
      idField: "region",
      textField: "region",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 1,
      allowSearchFilter: true,
    };
  }
  onRegionSelect(item: any) {
    this.parent = [];
    this.selectedRegion.push(item.region);
    let data = "'" + this.selectedRegion.join("','") + "'";
    this.apiReq.region = data;
    this.getAllParent(data);
  }
  onRegionAll(items: any) {
    this.selectedRegion = [];
    for (let i = 0; i < items.length; i++) {
      this.selectedRegion.push(items[i].region);
    }
    let data = "'" + this.selectedRegion.join("','") + "'";
    this.apiReq.region = data;
    this.parent = [];
    this.getAllParent(data);
  }

  onRegionDeSelect(item: any) {
    this.selectedRegion.splice(this.selectedRegion.indexOf(item.region), 1);
    let data = "'" + this.selectedRegion.join("','") + "'";
    this.apiReq.region = data;
    this.parent = [];
    this.getAllParent(data);
  }

  onRegionDeAll() {
    this.parent = [];
    this.selectedRegion = [];
    this.parentList = [];
    this.apiReq.region = "";
    this.getAllParent("''");
  }
  public advanceFilter() {
    this.currentPage = 1; // Reset to first page on new search
    this.getVirtualMappingData();
    this.firstTimeRun = false;
  }
  parentSetting() {
    this.parentDropdownSettings = {
      singleSelection: false,
      idField: "parent",
      textField: "parent",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 1,
      allowSearchFilter: true,
    };
  }
  onParentSelect(item: any) {
    this.selectedParent.push(item.parent);
    let data = "'" + this.selectedParent.join("','") + "'";
    this.apiReq.parent = data;
  }
  onParentAll(items: any) {
    this.selectedParent = [];
    for (let i = 0; i < items.length; i++) {
      this.selectedParent.push(items[i].parent);
    }
    let data = "'" + this.selectedParent.join("','") + "'";
    this.apiReq.parent = data;
  }

  onParentDeSelect(item: any) {
    this.selectedParent.splice(this.selectedParent.indexOf(item.parent), 1);
    let data = "'" + this.selectedParent.join("','") + "'";
    this.apiReq.parent = data;
  }

  onParentDeAll() {
    this.selectedParent = [];
    // this.outletList = [];
    this.apiReq.parent = "";
  }

  channelSetting() {
    this.channelDropdownSettings = {
      singleSelection: false,
      idField: "channel",
      textField: "channel",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 1,
      allowSearchFilter: true,
    };
  }
  onChannelSelect(item: any) {
    this.selectedChannel.push(item.channel);
    let data = "'" + this.selectedChannel.join("','") + "'";
    this.apiReq.channel = data;
    this.channelName = data;
    this.parent = [];
    this.getAllParent(this.apiReq.region);
  }
  onChannelAll(items: any) {
    this.selectedChannel = [];
    for (let i = 0; i < items.length; i++) {
      this.selectedChannel.push(items[i].channel);
    }
    let data = "'" + this.selectedChannel.join("','") + "'";
    this.parent = [];
    this.apiReq.channel = data;
    this.channelName = data;
    this.getAllParent(this.apiReq.region);
  }

  onChannelDeSelect(item: any) {
    this.selectedChannel.splice(this.selectedChannel.indexOf(item.channel), 1);
    let data = "'" + this.selectedChannel.join("','") + "'";
    this.apiReq.channel = data;
    this.parent = [];
    this.channelName = data;
    this.getAllParent(this.apiReq.region);
  }

  onChannelDeAll() {
    this.selectedChannel = [];
    this.parent = [];
    this.parentList = [];
    this.apiReq.channel = "";
    this.channelName = "";
    this.getAllParent(this.apiReq.region);
  }
  outletTypeSetting() {
    this.outletTypeDropdownSettings = {
      singleSelection: false,
      idField: "outlettype",
      textField: "outlettype",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 1,
      allowSearchFilter: true,
    };
  }
  onOutletTypeSelect(item: any) {
    this.selectedOutletType.push(item.outlettype);
    let data = "'" + this.selectedOutletType.join("','") + "'";
    this.apiReq.outletType = data;
    this.outletTypeName = data;
  }
  onOutletTypeAll(items: any) {
    this.selectedOutletType = [];
    for (let i = 0; i < items.length; i++) {
      this.selectedOutletType.push(items[i].outlettype);
    }
    let data = "'" + this.selectedOutletType.join("','") + "'";
    this.apiReq.outletType = data;
    this.outletTypeName = data;
  }

  onOutletTypeDeSelect(item: any) {
    this.selectedOutletType.splice(
      this.selectedOutletType.indexOf(item.outlettype),
      1
    );
    let data = "'" + this.selectedOutletType.join("','") + "'";
    this.apiReq.outletType = data;
    this.outletTypeName = data;
  }

  onOutletTypeDeAll() {
    this.selectedOutletType = [];
    this.apiReq.outletType = "";
    this.outletTypeName = "";
  }
  public getAllZone() {
    this.dataService.startLoader();
    let data = {
      loginInfo: {
        zone: this.apiReq.zone,
        region: this.apiReq.region,
        parent: this.apiReq.parent,
      },
    };
    this.dataService.postMaster("filter/getZone", data).subscribe(
      (res) => {
        this.dataService.stopLoader();
        if (res["code"] == 200) {
          this.zoneList = res["data"];
          let arr = [];
          for (let i = 0; i < this.zoneList.length; i++) {
            arr.push(this.zoneList[i].zone);
          }
          let data = "'" + arr.join("','") + "'";
          this.apiReq.zone = data;
          this.getAllRegion(data);
        } else {
          this.dataService.showError(res["message"]);
          if (res["code"] == 401) {
            this.dataService.logout();
          }
        }
      },
      (err) => {
        this.dataService.stopLoader();
        // this.dataService.showError(err['message']);
      }
    );
  }

  public getAllRegion(zoneName) {
    this.dataService.startLoader();
    let data;
    data = {
      loginInfo: {
        zone: this.apiReq.zone,
        region: this.apiReq.region,
        parent: this.apiReq.parent,
      },
      zone: zoneName,
    };
    if (this.loginData.userType === 8 || this.loginData.userType === 10) {
      data = {
        loginInfo: {
          zone: this.apiReq.zone,
          region: this.apiReq.region,
          parent: this.apiReq.parent,
        },
        zone: `'${this.loginData.zone}'`,
      };
    }
    this.dataService.postMaster("filter/getRegion", data).subscribe(
      (res) => {
        this.dataService.stopLoader();
        if (res["code"] == 200) {
          this.regionList = res["data"];
          let arr = [];
          for (let i = 0; i < this.regionList.length; i++) {
            arr.push(this.regionList[i].region);
          }
          let data = "'" + arr.join("','") + "'";
          this.apiReq.region = data;
          this.getAllChannel(data);
        } else {
          this.dataService.showError(res["message"]);
          if (res["code"] == 401) {
            this.dataService.logout();
          }
        }
      },
      (err) => {
        this.dataService.stopLoader();
        // this.dataService.showError(err['message']);
      }
    );
  }

  public getAllChannel(regionName) {
    this.dataService.startLoader();
    let data;
    data = {
      loginInfo: {
        zone: this.apiReq.zone,
        region: this.apiReq.region,
        parent: this.apiReq.parent,
      },
      region: regionName,
    };
    this.dataService.postMaster("filter/getAllChannel", data).subscribe(
      (res) => {
        this.dataService.stopLoader();
        if (res["code"] == 200) {
          this.channelList = res["data"];
          let arr = [];
          for (let i = 0; i < this.channelList.length; i++) {
            arr.push(this.channelList[i].channel);
          }
          let data = "'" + arr.join("','") + "'";
          this.apiReq.channel = data;
          this.channelName = data;
          this.getAllParent(regionName);
        } else {
          this.dataService.showError(res["message"]);
          if (res["code"] == 401) {
            this.dataService.logout();
          }
        }
      },
      (err) => {
        this.dataService.stopLoader();
        // this.dataService.showError(err['message']);
      }
    );
  }

  public getAllParent(regionName) {
    this.dataService.startLoader();
    let data;
    data = {
      loginInfo: {
        zone: this.apiReq.zone,
        region: this.apiReq.region,
        parent: this.apiReq.parent,
      },
      region: regionName,
      channel: this.channelName,
    };
    if (this.loginData.userType === 6) {
      data = {
        loginInfo: {
          zone: this.apiReq.zone,
          region: this.apiReq.region,
          parent: this.apiReq.parent,
        },
        region: `'${this.loginData.region}'`,
        channel: this.channelName,
      };
    }
    this.dataService.postMaster("filter/getParent", data).subscribe(
      (res) => {
        this.dataService.stopLoader();
        if (res["code"] == 200) {
          this.parentList = res["data"];
          let arr = [];
          for (let i = 0; i < this.parentList.length; i++) {
            arr.push(this.parentList[i].parent);
          }
          let data = "'" + arr.join("','") + "'";
          this.apiReq.parent = data;
          // this.getAllOutlet(data);
          this.getAllOutletType(data);
        } else {
          this.dataService.showError(res["message"]);
          if (res["code"] == 401) {
            this.dataService.logout();
          }
        }
      },
      (err) => {
        this.dataService.stopLoader();
        // this.dataService.showError(err['message']);
      }
    );
  }

  public getAllOutletType(regionName) {
    this.dataService.startLoader();
    let data;
    data = {
      loginInfo: {
        zone: this.apiReq.zone,
        region: this.apiReq.region,
        parent: this.apiReq.parent,
      },
      // region: regionName,
    };
    this.dataService.postMaster("filter/getAllOutletType", data).subscribe(
      (res) => {
        this.dataService.stopLoader();
        if (res["code"] == 200) {
          this.outletTypeList = res["data"];
          let arr = [];
          for (let i = 0; i < this.outletTypeList.length; i++) {
            arr.push(this.outletTypeList[i]["outlettype"]);
          }
          let data = "'" + arr.join("','") + "'";
          this.apiReq.outletType = data;
          this.outletTypeName = data;
        } else {
          this.dataService.showError(res["message"]);
          if (res["code"] == 401) {
            this.dataService.logout();
          }
        }
      },
      (err) => {
        this.dataService.stopLoader();
        // this.dataService.showError(err['message']);
      }
    );
  }

  download() {
    this.dataService.startLoader();
    let finalData = {
      zone: this.apiReq.zone,
      region: this.apiReq.region,
      parent: this.apiReq.parent,
      outletType: this.apiReq.outletType,
      channel: this.apiReq.channel,
      search: (this.searchText && this.searchText.trim()) || "",
    };
    this.dataService.post("vnMapping/vn-mapping-data", finalData).subscribe(
      (res) => {
        this.dataService.stopLoader();
        if (res["code"] == 200) {
          if (res["data"]["data"].length) {
            this.ExcelService.exportAsExcelFile(
              res["data"]["data"],
              "virtual_number_report"
            );
          } else {
            this.dataService.showError("No Data Found.");
          }
        } else {
          this.dataService.showError(res["message"]);
          if (res["code"] == 401) {
            this.dataService.logout();
          }
        }
      },
      (err) => {
        this.dataService.stopLoader();
        this.dataService.showError(err);
      }
    );
  }
  public getVirtualMappingData() {
    // set default page view
    this.virtualNumberData = [];
    this.totalPages = this.totalRecords = 0;
    this.isLastPage = false;

    this.dataService.startLoader();
    let finalData = {
      zone: this.apiReq.zone,
      region: this.apiReq.region,
      parent: this.apiReq.parent,
      outletType: this.apiReq.outletType,
      channel: this.apiReq.channel,
      search: (this.searchText && this.searchText.trim()) || "",
      page: this.currentPage,
      limit: this.pageSize,
    };
    this.dataService.post("vnMapping/vn-mapping-data", finalData).subscribe(
      (res) => {
        this.dataService.stopLoader();
        if (res["code"] == 200) {
          this.virtualNumberData = res["data"]["data"];
          this.totalRecords = res["data"]["totalCount"] || 0;
          this.totalPages = res["data"]["totalPages"] || 0;
          this.isLastPage =
            this.currentPage * this.pageSize >= this.totalRecords;
          // this.qslSplitChart(res["data"]);
        } else {
          this.dataService.showError("Something went wrong");
          if (res["code"] == 401) {
            this.dataService.logout();
          }
        }
      },
      (err) => {
        this.dataService.stopLoader();
        this.dataService.showError(err);
      }
    );
  }
  nextPage() {
    if (!this.isLastPage) {
      this.currentPage++;
      this.getVirtualMappingData();
    }
  }

  previousPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.getVirtualMappingData();
    }
  }

   public clearFilter() {
    this.dataService.removeCookies("hyperLocalFilter", "");

       this.selectedZone = [];
  this.selectedRegion = [];
  this.selectedParent = [];
  this.selectedChannel = [];
  this.selectedOutletType = [];

    window.location.reload();
  }
}
